const normalizeTitle = (title) => (typeof title === "string" ? title.trim().toLowerCase() : "");

export const getCalendarEventTypeClass = (event) => {
    if (!event || !event.title) {
        return null;
    }

    const normalized = normalizeTitle(event.title);

    if (normalized.includes("monster") && normalized.includes("dyp")) {
        return "monster-dyp";
    }

    if (normalized.startsWith("offenes einzel")) {
        return "offenes-einzel";
    }

    return null;
};
